// extracted by mini-css-extract-plugin
module.exports = {"list":"pay_list_2c4Vi","card":"pay_card_28-C2","sdhat":"pay_sdhat_1AaJ0","img":"pay_img_1XGIr","img1":"pay_img1_1b9YW"};